import { defaultPagination } from "app/redux/initialState";
import { TimeZoneState } from "../type";

export const initialState: TimeZoneState = {
  list: [],
  isLoading: false,
  pagination: {...defaultPagination, perPage: 20},
  
  
};
